module.exports = __webpack_public_path__ + "img/financial_wellness.66f0b71b.jpg";